import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Container } from 'reactstrap';
import ListSearch from './listSearch';
import ListResult from './listResult';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { listRequest as listRequestAction, listClear as listClearAction, downloadRequest as downloadRequestAction } from '../../store/userCourses/actions'
import { listRequest as listUserRequestAction, selectData as selectUserDataAction} from '../../store/users/actions';
import { getUserCourses } from '../../store/userCourses/selectors';
import { getSelectedUser } from '../../store/users/selectors';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import {
    Button, Col, Row, Spinner, Form, FormGroup, Input,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label
} from 'reactstrap';
import UserTopNav from '../../components/userTopNav';
import { timeStamp } from 'console';

interface IState {
    id : string
    term: string
    sorting: string
    offset: number
    limit: number
}

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    userData : any
    data: any
    ui: any
    selectedUserId : string
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest: typeof listRequestAction
    listClear: typeof listClearAction
    listUserRequest : typeof listUserRequestAction
    selectUserData : typeof selectUserDataAction
    downloadRequest: typeof downloadRequestAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class UserCourseMainPage extends React.Component<AllProps, IState> {
    downloadLink : any = {};

    constructor(props: AllProps) {
        super(props);
        let limit = this.props.ui?.searchParams?.limit ?? 10;
        if (limit === 1) limit = 10;
        this.state = {
            id : this.props.ui?.searchParams?.oId ?? '',
            term: this.props.ui?.searchParams?.term ?? '',
            sorting: this.props.ui?.searchParams?.sorting ?? '',
            offset: this.props.ui?.searchParams?.offset ?? 0,
            limit: limit
        };
        this.DownloadRequest = this.DownloadRequest.bind(this);
    }

    public componentDidMount() {
        let id = this.props.route.match.params.id;
        const parsed = queryString.parse(this.props.route.location.search);
        const { searchParams: stateSP } = this.props.ui;

        var sTerm = '';
        var sSorting = '';
        if (parsed.term) sTerm = parsed.term.toString();
        if (parsed.sorting) sSorting = parsed?.sorting.toString() ?? "Title";

        // Compare if different only query again
        let isNewSearch = true;
        if ((stateSP != undefined) && (
            stateSP.oId === id  &&
            stateSP.term === sTerm &&
            stateSP.sorting === sSorting &&
            stateSP.offset === this.state.offset &&
            stateSP.limit === this.state.limit
        )) {
            isNewSearch = false;
        }

        if (isNewSearch) {
            this.setState({
                id : id,
                term: sTerm,
                sorting: sSorting
            }, () => {
                this.ListRequest();
            });
        }

        if (this.props.userData === undefined){
            this.props.selectUserData(id);
        }
    }

    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.selectedUserId === undefined && this.props.selectedUserId !== undefined && this.props.userData === undefined){
             this.readUserData();
        }

        // Show notification
        if (prevProps.ui.processState != this.props.ui.processState) {
            let notification = { show: false, title: "", type: "", message: "" };

            if (this.props.ui.processState === 1) { // List success

            } else if (this.props.ui.processState === 2) { // List failed
                notification.show = true;
                notification.type = "danger";
                notification.message = "Process failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show) {
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                });
            }
        }
        
        if (prevProps.ui.downloading === true && this.props.ui.downloading === false ) {
            if (this.props.ui.processState === 1) { // List success
                console.log("Download URL :" + this.props.ui.downloadURL);
                //window.URL.revokeObjectURL(this.props.ui.downloadUrl);
               // this.refs.download.click();
               this.downloadLink.click();
            } else if (this.props.ui.processState === 2) { // List failed
                // notification.show = true;
                // notification.type = "danger";
                // notification.message = "Process failed. Error : \n" + this.props.ui.errors;
            }
        }
    }

    public componentWillUnmount() {
    }

    readUserData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.selectedUserId;
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listUserRequest(searchParams);
    }

    private Search(d: any) {
        this.setState({
            offset: 0,
            term: d?.term ?? "".toLowerCase(),
        }, () => {
            this.props.route.history.push('?term=' + d.term + '&sorting=' + this.state.sorting);
            this.ListRequest();
        });
    }
    private LoadMore(d: any) {
        this.setState({ offset: this.state.offset + this.state.limit }, () => {
            this.ListRequest();
        });
    }

    private Sorting(d: any) {
        this.setState({ offset: 0, sorting: d.searchSorting }, () => {
            this.props.route.history.push('?term=' + this.state.term + '&sorting=' + this.state.sorting);
            this.ListRequest();
        });
    }
    private ListRequest(){
        var searchParams: any = {};
        searchParams["oId"] = this.state.id;
        searchParams["term"] = this.state.term;
        searchParams["sorting"] = this.state.sorting;
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        this.props.listRequest(searchParams);
    }

    private DownloadRequest(){
        var searchParams: any = {};
        searchParams["oId"] = this.state.id;
        searchParams["term"] = this.state.term;
        searchParams["sorting"] = this.state.sorting;
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        this.props.downloadRequest(searchParams);
    }

    public render() {
        const { ui } = this.props.ui;
        return (
            <Container>
                <UserTopNav activeTab = "Courses" selectedUserId ={this.props.selectedUserId} />
                <Form  className="mt-3 mb-3">
                    <FormGroup row={true}>
                        <Label for="fullName" sm={2}>Name</Label >
                        <Col lg={6} sm={10}>
                            <Input type="text" name="fullName" defaultValue={this.props.userData?.fullName} readOnly={true} />
                        </Col>
                    </FormGroup>
                </Form>
                <ListSearch onSearch={this.Search.bind(this)}
                    term={this.state.term}
                    loading={this.props.ui.loading} />
                <br />
                {/* <RouterNavLink to={"/users/new"}>
                    <Button color="success"><i className="fas fa-plus mr-1"></i>Add New</Button>
                </RouterNavLink> */}
                <ListResult
                    selectedUserId ={this.props.selectedUserId} 
                    onLoadMore={this.LoadMore.bind(this)}
                    onSorting={this.Sorting.bind(this)}
                    onDownload={this.DownloadRequest.bind(this)}
                    downloading={this.props.ui.downloading}
                    term={this.state.term}
                    sorting={this.state.sorting}
                    data={this.props.data}
                    loading={this.props.ui.loading}
                    totalDocument={this.props.ui.totDoc}
                    offset={this.state.offset} limit={this.state.limit} />
                    
                    <a ref={input => this.downloadLink = input} 
                        href={this.props.ui.downloadURL} download="userCourse.csv" style={{display:"none"}}></a>
                    <br/><br/>
            </Container>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.userCourse.ui,
    selectedUserId : state.user.ui.selected,
    data: getUserCourses(state),
    userData : getSelectedUser(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest: listRequestAction,
    listClear: listClearAction,
    listUserRequest : listUserRequestAction,
    selectUserData : selectUserDataAction,
    downloadRequest: downloadRequestAction,
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserCourseMainPage)
